function prepareTimezone (dayjs, value, forceUtc, timezone) {
  if (forceUtc) {
    return new Date(dayjs.utc(value).format("YYYY/MM/DD HH:mm"));
  } else if (timezone) {
    return new Date(dayjs(value).tz(timezone).format("YYYY/MM/DD HH:mm"));
  } else {
    return new Date(value);
  }
}

function capitalize (value) {
  if (!value) return "";
  value = value.toString();

  return value.charAt(0).toUpperCase() + value.slice(1);
}

function underscore (str) {
  return str.replace(/-/g, " ");
}

function humanize (str, useTranslations = false) {
  if (useTranslations) {
    let string, scope, key;
    string = str.replace(/[0-9]|\]/g, "").split("[").filter(item => item).map(item => camelize(item));
    scope = string.shift();
    key = string.join(".");

    return `${scope}.${key}`;
  } else {
    return str.split("[").pop().split("]")[0].trim().split(/\s+/).map(function (str) {
      return str.replace(/_/g, " ").replace(/\s+/, " ").trim();
    }).join(" ").toLowerCase().replace(/^./, function (m) {
      return m.toUpperCase();
    });
  }
}

function titleize (str) {
  if (!str.split) return str;

  return underscore(str).toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
}

function pluralize (str, number = 2) {
  if (number === 1) {
    return str;
  }

  let pluralRegExps = {
    "(quiz)$": "$1zes",
    "^(ox)$": "$1en",
    "([m|l])ouse$": "$1ice",
    "(matr|vert|ind)ix|ex$": "$1ices",
    "(x|ch|ss|sh)$": "$1es",
    "([^aeiouy]|qu)y$": "$1ies",
    "(hive)$": "$1s",
    "(?:([^f])fe|([lr])f)$": "$1$2ves",
    "(shea|lea|loa|thie)f$": "$1ves",
    "sis$": "ses",
    "([ti])um$": "$1a",
    "(tomat|potat|ech|her|vet)o$": "$1oes",
    "(bu)s$": "$1ses",
    "(alias)$": "$1es",
    "(octop)us$": "$1i",
    "(ax|test)is$": "$1es",
    "(us)$": "$1es",
    "([^s]+)$": "$1s"
  };

  for (const regExp in pluralRegExps) {
    var pattern = new RegExp(regExp, "i");

    if (pattern.test(str)) return str.replace(pattern, pluralRegExps[regExp]);
  }

  return str;
}

function singularize (str) {
  return str.slice(0, -1);
}

function dasherize (str) {
  return str
    .replace(/([A-Z])/g, "-$1")
    .replace(/[[\]-_\s]+/g, "-")
    .replace(/[-]+$/, "")
    .toLowerCase();
}

function camelize (str, downcaseFirstLetter = false) {
  let result = str.replace(/^([A-Z])|[\s-_](\w)/g, function (_1, _2, p2, _3) {
    if (p2) return p2.toUpperCase();
  });

  if (downcaseFirstLetter) { return result.charAt(0).toLowerCase() + result.slice(1); }

  return result;
}

function formatDecimal (value, precision) {
  return parseFloat(value).toLocaleString("en-US", { minimumFractionDigits: precision });
}

function formatPercentage (value) {
  return parseFloat(value).toString() + "%";
}

function formatDateTime (dayjs, value, forceUtc, timezone) {
  if (!value) return "";

  return prepareTimezone(dayjs, value, forceUtc, timezone).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false
  });
}

function formatCurrency (value, currency, minimumFractionDigits) {
  return parseFloat(value || 0).toLocaleString("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: minimumFractionDigits
  });
}

function simpleFormat (value) {
  if (!value) return "";

  value = value.toString();
  return value.split("\n").join("<br>");
}

export {
  capitalize,
  humanize,
  titleize,
  underscore,
  pluralize,
  singularize,
  dasherize,
  camelize,
  formatDecimal,
  formatPercentage,
  formatDateTime,
  formatCurrency,
  simpleFormat,
  prepareTimezone
};
